module.exports = __webpack_public_path__ + "img/present_icon.f8363abd.svg";